import {appConstants} from '../_constants';
// import {apiService} from '../_services';
import { alertActions } from './alert.actions';
import axios from "axios/index";

function get(url) {
    return dispatch => {
        dispatch(startRequest());

        let reqHeader = {'Content-Type': 'application/json', 'AppName' : appConstants.APP_ID};
        let config = {headers: reqHeader};

        return axios.get(url, config).then(function (res) {
            // console.log('Response: ', res);
            dispatch(alertActions.success(res.data));
            dispatch(success('Done'));

        }).catch((error) => {
            /*console.log(error.message);
            console.log(error.code); // Not always specified
            console.log(error.config); // The config that was used to make the request
            // console.log(error.response); // Only available if response was received from the server*!/*/

            let errorMessage = (error.response.data) ? error.response.data : 'Unable to handle request';

            dispatch(failure(errorMessage));
            dispatch(alertActions.error(errorMessage));
        });
    };
}

function post(payload, url) {
    return dispatch => {
        dispatch(startRequest());

        let reqHeader = {'Content-Type': 'application/json', 'AppName' : appConstants.APP_ID};
        let config = {headers: reqHeader};

        let stringifyPayload = JSON.stringify(payload);

        return axios.post(url, stringifyPayload, config).then(function (res) {
            dispatch(alertActions.success(res.data));
            dispatch(success('Done'));

        }).catch((error) => {
            /*console.log(error.message);
            console.log(error.code); // Not always specified
            console.log(error.config); // The config that was used to make the request
            console.log(error.response); // Only available if response was received from the server*!/*/

            let errorMessage = (error.response.data) ? error.response.data : 'Unable to handle request';

            dispatch(failure(errorMessage));
            dispatch(alertActions.error(errorMessage));
        });
    };
}

//DONT REMOVE THE FOLLOWING CODE

function startFullPageRequest() { return { type: appConstants.API_REQUEST_FULL_PAGE_START } }
function startRequest() { return { type: appConstants.API_REQUEST_START } }
function endRequest() { return { type: appConstants.API_REQUEST_FINISH } }
function success(response) { return { type: appConstants.REQUEST_SUCCESS, response } }
function failure(message) { return { type: appConstants.REQUEST_FAILURE, message } }

export const apiActions = {
    get,
    post,
    startRequest,
    startFullPageRequest,
    endRequest,
};



// WEBPACK FOOTER //
// ./src/_actions/api.actions.js